export function determineMostRecentRun(runs, scenarioId) {
  // determine the most recent run for a given scenario using startedAt
  const scenarioRuns = runs.filter(r => r.scenarioId === scenarioId)
    .sort((a, b) => b.startedAt > a.startedAt);
  return scenarioRuns.first();
}

export const runningJobStatuses = ['starting', 'launching', 'running', 'requested', 'unknown'];
export const completedJobStatuses = ['finished', 'failed'];

export function determineStatus(lastRun) {
  // if no lastRun, call it a draft. Otherwise call it whatever the run says
  if (!lastRun) {
    return 'draft';
  }
  return lastRun.status.toLowerCase();
}

export function sortScenarios(scenarios) {
  // Sort scenarios by id desc
  if (scenarios.size > 1) {
    return scenarios.sort((a, b) => b.id - a.id);
  }
  return scenarios;
}
